import { firebase, getRef } from './config/firebase';

export const updateLastUpdatedTimestamp = () => {
  return getRef('/content/last_updated').set(firebase.database.ServerValue.TIMESTAMP);
}

export const sortOrderAsc = (a, b) => {
  if (a.order < b.order) {
    return -1;
  } else if (a.order > b.order) {
    return 1;
  }
  return 0;
};

export const getAllItems = (ref, cb, isSortable = true) => {
  ref.on('value', (snapshot) => {
    let items = snapshot.val() || {};

    items = Object.keys(items)
      .map((key, index) => {
        const item = items[key];
        item.id = key;
        if (isSortable) {
          item.order = item.order !== undefined ? item.order : index;
        }
        return item;
      });

    if (isSortable) {
      items = items.sort(sortOrderAsc);
    }

    cb(items);
  });
}

export function getDuration(file: Blob, type: 'audio' | 'video'): Promise<number> {
  if (!file) {
    return Promise.resolve(0);
  }

  const src = window.URL.createObjectURL(file);

  const tempEl = document.createElement(type);

  return new Promise((resolve) => {
    tempEl.addEventListener('loadedmetadata', () => {
      const { duration } = tempEl;
      tempEl.remove();
      return resolve(duration);
    });
    tempEl.src = src;
  });
}

// Inspired by https://github.com/Idnan/SoundCloud-Waveform-Generator
export function getAudioWaveformData(file: File, length: number): Promise<Array<number>> {
  if (!file || !length || !file.name.endsWith('.mp3')) {
    return Promise.resolve([]);
  }

  const bufferMeasure = (position, blockSize, data) => {
    let sum = 0.0;
    for (let i = position; i <= (position + blockSize) - 1; i += 1) {
      sum += data[i] ** 2;
    }
    return Math.sqrt(sum / data.length);
  };

  return new Promise((resolve, reject) => {
    try {
      const audioContext = new AudioContext();
      const reader = new FileReader();

      reader.onload = async (event) => {
        const buffer: AudioBuffer = await audioContext.decodeAudioData(event.target.result);
        const data = buffer.getChannelData(0);
        const blockSize = Math.floor(data.length / length);
        let waveformData = [];

        for (let i = 0; i < length; i += 1) {
          waveformData.push(bufferMeasure(i * blockSize, blockSize, data));
        }

        // apply scale "1" & round waveformData to upto 2 decimal places
        const scale = 1 / Math.max(...waveformData);
        waveformData = waveformData.map(value => Math.round(value * scale * 100) / 100);

        resolve(waveformData);
      };

      reader.readAsArrayBuffer(file);
    } catch (e) {
      reject(e);
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils.js